import { Entity } from '@data-client/rest';
import { ISODate } from '../utils/transforms';
class OrganizationDomainEntity extends Entity {
    constructor() {
        super(...arguments);
        this.creationDTTM = new Date(0);
        this.domain = null;
        this.organizationDomainId = 0;
        this.organizationId = 0;
    }
    pk() {
        return this.organizationDomainId.toString();
    }
}
OrganizationDomainEntity.schema = {
    creationDTTM: ISODate
};
OrganizationDomainEntity.key = 'OrganizationDomain';
export { OrganizationDomainEntity };
